import { useQueryClient } from 'react-query';
import useHttpMutation from 'data/firestore/useHttpMutation';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthPatientLinkList } from '../types';

const useUnlinkNexhealthPatient = (agentId: string, customerId: string) => {
    const queryClient = useQueryClient();

    return useHttpMutation<undefined, string>({
        method: 'DELETE',
        server: ACTIONS_BASE_URL,
        onSuccess: () => {
            queryClient.setQueryData<NexhealthPatientLinkList>(
                ['nexhealth', 'patient-link', agentId, customerId],
                { data: [], page: { nextCursor: null } },
            );
        },
    });
};

export default useUnlinkNexhealthPatient;
